import { Box, Paper } from '@mui/material';
import React from 'react';
import { useGetGoogleCalendars } from '../../../services/react-query/integrations/google_calendar/useGetGoogleCalendars';
import { headerTypographyProps } from '../../../styles/sxStyling';
import { Calendar } from '../../../types/Calendar';
import { CalendarPartner, IntegrationProps } from '../../../types/Integration';
import CalendarAutocompleteSelect from './CalendarAutoComplete';

export default function GoogleEventTemplateIntegration({ integration, setIntegration }: IntegrationProps) {
  const { data: calendarResponse, isLoading } = useGetGoogleCalendars({ enabled: true });
  const calendars: Calendar[] = calendarResponse?.data ?? [];
  const calendarId = integration?.settings?.calendar_id ?? '';

  const handleChange = (calendar: Calendar | null) => {
    if (!calendar) return setIntegration(null);

    setIntegration({
      uuid: integration?.uuid || crypto.randomUUID(),
      partner: CalendarPartner.GOOGLE,
      enabled: true,
      settings: { calendar_id: calendar.id, calendar_name: calendar.name },
    });
  };

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%', p: 1 }}>
      <Box sx={{ ...headerTypographyProps }}>Google Calendar</Box>
      <CalendarAutocompleteSelect
        id="google_calendar"
        label="Select Google Calendar"
        calendars={calendars}
        selectedCalendarId={calendarId}
        onChange={handleChange}
        loading={isLoading}
      />
    </Paper>
  );
}
